(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../components/Theme"), require("../../utils/get-contrast"), require("colord"));
	else if(typeof define === 'function' && define.amd)
		define(["../../components/Theme", "../../utils/get-contrast", "colord"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../components/Theme"), require("../../utils/get-contrast"), require("colord")) : factory(root["../../components/Theme"], root["../../utils/get-contrast"], root["colord"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__219__, __WEBPACK_EXTERNAL_MODULE__174__, __WEBPACK_EXTERNAL_MODULE__235__) {
return 